export default __webpack_public_path__ + "static/media/Bongai_Mhloyi_AHV_In_Moms_We_Trust.7258e3ee.jpg";